/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { ScheduleWindowDay } from './scheduleWindowDay';

/**
 * One row of a sending-window schedule (Mon..Sun).
 */
export interface ScheduleWindow {
  day: ScheduleWindowDay;
  enabled: boolean;
  start?: string | null;
  end?: string | null;
}
